import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChartMedium = ({ metricsData }) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false, // Ensures better control over height
    plugins: {
      legend: {
        position: "bottom",
        align: "center", // Centers the legend
        display: true,
        labels: {
          usePointStyle: false, // Disable bullet points
          boxWidth: 0, // Hide color box
          color: "#768B9F", // Keep label color
          padding:20,
          font:{
             size:14,
             weight:500,
             fontFamily:"Satoshi"
          }
        },
      },
      tooltip: {
        enabled: false, 
        display:false,
        callbacks: {
          label: (context) => `$${context.raw.toLocaleString()}`,
        },
      },
    },
    scales: {
      x: {
        border: {
          display: false,
        },
        grid: {
          display: true, 
        },
        ticks: {
          autoSkip: false, 
        },
        offset: true,
      },
      y: {
        grace:"30%",
        beginAtZero: true,
        grid: {
          display: false, 
        },
        border: {
          display: false,
        },
        ticks: {
          callback: (value) => `${value.toLocaleString()}`,
          maxTicksLimit: 7,
        },
      },
    },
    barThickness: 140,
  };

  const topLine = {
  id: "topLine",
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart;

    ctx.save();
    chart.getDatasetMeta(0).data.forEach((datapoint, index) => {
      ctx.beginPath();
      const halfWidth = datapoint.width / 2;
      ctx.moveTo(datapoint.x - halfWidth, datapoint.y - 6);
      ctx.lineTo(datapoint.x + halfWidth, datapoint.y - 6);

      const value = `${data.datasets[0].data[index]} Customers`;

      // Styling the text
      ctx.font = "14px Satoshi";
      ctx.fillStyle = "#768B9F";
      ctx.textAlign = "center";
      ctx.fillText(value, datapoint.x, datapoint.y - 10);
    });
    ctx.restore();
  },
};


  const data = {
    labels: ["< 30 Days", "30-45 Days",  "45-60 Days" , "60-90 Days" , "90 Days" ],
    datasets: [
      {
        label: "Average Time to First Renewal",
        data: [20, 30 , 40, 50, 50], 
        backgroundColor: [
          "#1E90FE"
        ],
        borderColor: "#ffffff", 
        borderWidth: 0, 
        borderRadius: 2, 
      },
    ],
  };
  

  return (
    <div style={{ height: "500px", display: "flex", alignItems: "center" }}>
      <Bar options={options} data={data}  plugins={[topLine]}/>
    </div>
  );
};

export default BarChartMedium;